<template>
    <div class="content-loading__wrap">
        <h2 class="content-loading">
            Loading...
        </h2>
    </div>
</template>
<script>
    export default {
        name: 'ContentLoading'
    }
</script>
<style lang="scss" scoped>
    .content-loading {
        font-weight: normal;
        color: rgba(0,0,0,0.15);
        margin: 0;
        &__wrap {
            width: calc(100% - 120px);
            max-width: 1080px;
            margin: 0 auto;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;
            border: 2px dashed rgba(0,0,0,0.15);
            border-radius: 5px;
            height: 100px;
        }

        font-size: $dashboard-font-size-heading;

        @include breakpoint ('max-width', $dashboard-breakpoint) {
            font-size: 18px;
        }
    }
</style>